import { Anchor, Box, Button, Heading, Image, Markdown, Paragraph, ResponsiveContext, Stack } from "grommet";
import * as React from "react";
import DarkModeSwitch, { useDarkMode } from "../components/DarkModeSwitch";

import { SignInButton } from "../utils/SignInButton";
import { GetGuides } from "../utils/IdentityAPI";
import { HelpText, HelpText1, HelpText2, RulesText } from "../utils/LocalizationStore";
import styled from "styled-components";
import StyledModal from "../components/StyledModel";
import { ButtonWrapper } from "../components/ButtonWrapper";
import ProcessGraph from "../components/ProcessGraph";

import AsteroidsGame from "../components/AsterioidsGame";
import ScrollContainer from "../components/ScrollContainer";

const Splash = () => {
    const [showHelp, setShowHelp] = React.useState(false);
    const [guides, setGuides] = React.useState([] as any[]);

    React.useEffect(() => {
        GetGuides("ssa-minecraft-knowledge-check").then((res) => {
            setGuides(res.value);
        });
    }, []);

    const maxSize = screen?.width > 800 ? "250px" : "50%";
    const logoMaxSize = screen?.width > 600 ? "400px" : "75%";
    const brandMaxSize = screen?.width > 600 ? "300px" : "75%";
    const [isDarkMode, toggleDarkMode] = useDarkMode();

    const [showGetStarted, setShowGetStarted] = React.useState(false);

    const size = React.useContext(ResponsiveContext);

    return (
        <>
            <AsteroidsGame style={{ opacity: 0.3 }}></AsteroidsGame>

            <Box align="center">
                <Image margin="small" alignSelf="center" fit="contain" src={"/images/logo2.png"} width={logoMaxSize} />
                <Heading level={2} margin="small">
                    Code the Climate Hackathon
                </Heading>
                <Box margin={{ vertical: "medium" }}>
                    <Image margin="small" alignSelf="center" fit="contain" src="/images/robot.jpeg" width={maxSize} />
                </Box>
                {(size == "medium" || size == "large" || size == "xlarge") && (
                    <Box direction="row" gap="small">
                        <Markdown>{HelpText1}</Markdown>
                        <Markdown>{HelpText2}</Markdown>
                    </Box>
                )}
                {size == "small" && (
                    <>
                        <Markdown>{HelpText}</Markdown>
                    </>
                )}
                <Box margin={{ vertical: "medium" }}>
                    <ButtonWrapper>
                        <Button primary style={{ fontSize: "32px" }} size="large" onClick={() => setShowGetStarted(true)} label={"Get Started"}></Button>
                    </ButtonWrapper>
                </Box>

                <StyledModal isOpen={showGetStarted} setIsOpen={() => setShowGetStarted(false)}>
                    <Box width={"large"}>
                        <ScrollContainer direction={"-y"}>
                            <Box direction={size != "small" ? "row" : "column"} gap="small" justify="center" align="center">
                                <Box>
                                    <Markdown>{RulesText}</Markdown>
                                    <Image margin="small" alignSelf="center" fit="contain" src={"/images/unisa_hack.png"} width={brandMaxSize} />
                                </Box>
                                <ProcessGraph></ProcessGraph>
                            </Box>
                            <Box direction="row" justify="evenly" gap="small">
                                <Button onClick={() => setShowGetStarted(false)} label={"Cancel"}></Button>
                                <SignInButton></SignInButton>
                            </Box>
                        </ScrollContainer>
                    </Box>
                </StyledModal>

                {showHelp && (
                    <>
                        <Box direction="row" gap="small" wrap pad={{ top: "medium" }} align="center" justify="center">
                            {guides.map((guide) => (
                                <Anchor target="_blank" href={guide.guideURI}>
                                    <Box key={guide.id} hoverIndicator="background-back" round="xsmall" pad="xsmall" align="center">
                                        <Image width={"200px"} height={"150px"} style={{ minWidth: "200px", minHeight: "150px" }} src={guide.thumbnailURI} fit="cover"></Image>
                                        {guide.name}
                                    </Box>
                                </Anchor>
                            ))}
                        </Box>
                    </>
                )}
            </Box>
        </>
    );
};

export default Splash;
